import React from 'react'
import { component_tool, framework_tool } from '../../../tool';
let { WizModal, WizButton } = component_tool;
let { WizContainer } = framework_tool;

import LookUpMenu from './lookUpMenu'

let ref

//配置项
let componentName = 'menu'

const columns = [
  {
    title: "菜单名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {},
    tableItem: {}
  },
  {
    title: "编号",
    name: "number",
    dataIndex: "number",
    formItem: {},
    searchItem: {},
    tableItem: {}
  },
  {
    title: "类型",
    name: "type",
    dataIndex: "type",
    formItem: {
      type: "select"
    },
    dict: [
      { code: 0, codeName: "文件夹" },
      { code: 1, codeName: "菜单" }
    ],
    searchItem: {
      type: "select"
    },
    tableItem: {}
  },
  {
    title: "状态",
    name: "disabled",
    dataIndex: "disabled",
    tableItem: {},
    dict: [
      { code: 0, codeName: "有效" },
      { code: 1, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    formItem: {
      type: "select"
    }
  },
  {
    title: "是否展示",
    name: "exhibition",
    dataIndex: "exhibition",
    tableItem: {},
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    dict: [
      { code: 1, codeName: "是" },
      { code: 0, codeName: "否" }
    ]
  },
  {
    title: "上级菜单",
    name: "parentName",
    dataIndex: "parentName",
    formItem: {},
    searchItem: {},
    tableItem: {}
  },
  {
    title: "顺序",
    name: "orderNumber",
    dataIndex: "orderNumber",
    formItem: {},
    tableItem: {}
  },
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    formItem: {},
    tableItem: {}
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        collapse: true,
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        buttonSort: ['add', 'batchEnable', 'batchDisable', 'export'],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/auth/menu/menuDetailAdd"
              }
            }

          },
          {
            key: "batchEnable",
            custom: true,
            needSelect: true,
            params: { children: "批量启用", type: "checkbox" },
            customOnClick: {
              //'customOnClick:fun'
              key: "action",
              params: {
                apiKey: "changeDisable"
              },
              formatParams: (rows, record, filters, callback) => {
                let ids = [];
                rows.forEach(row => {
                  ids.push(row.id)
                }
                )
                const content = `${"您确定要启用选中的菜单吗?"}`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      disabled: 0,
                      ids: ids,
                      ...filters
                    })
                  },
                  onCancel() { }
                });
                return null
              }
            }
          },
          {
            key: "batchDisable",
            custom: true,
            needSelect: true,
            params: { children: "批量禁用", type: "checkbox" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "changeDisable"
              },
              formatParams: (rows, record, filters, callback) => {
                let ids = [];
                rows.forEach(row => {
                  ids.push(row.id)
                }
                )
                const content = `${"您确定要禁用选中的菜单吗?"}`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      disabled: 1,
                      ids: ids,
                      ...filters
                    })
                  },
                  onCancel() { }
                });
                return null
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filter) => {
                return { ...filter };
              }
            }
          }
        ]
      },
      siderBarProps: {
        searchKey: "parentId",
        // onSelect:(selectedKeys, { selected, selectedNodes, node, event })=>{
        //   console.log('======'+node.props.id)
        // },
        otherProps: {
          key: "typeNodeList"
        },
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "",
            children: ""
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['look', 'update', 'authorityManagement', 'enableOrDisable'],
      rowOperateView: [
        {
          key: "look",
          custom: true,
          params: { children: "查看" },
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "查看菜单",
                diy: (e) => {
                  return (
                    <LookUpMenu
                      key={'roleManagement' + e.record.id}
                      {...e}
                    />
                  )
                },
                footer:null,
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/auth/menu/menuDetailUpd"
            }
          }

        },
        {
          key: "authorityManagement",
          custom: true,
          params: { children: "权限管理" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/auth/menu/menuPower"
            },
          },    
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.disabled === 0) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用" },
          textFormat: {
            recordKey: 'disabled',
            dirt: { 0: '禁用', 1: '启用' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "changeDisable"
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `${record['disabled'] === 0 ? record['type'] === 0 ? "您确定要禁用菜单[" + record.name + "]并禁用该菜单下所有的子菜单吗?" : "您确定要禁用菜单[" + record.name + "]吗?" : "该菜单是禁用状态，您确定要启用?"}`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    disabled: record['disabled'] === 0 ? 1 : 0,
                    ids: [record['id']],
                  })
                },
                onCancel() { }
              });
              return null
            }
          }
        }
      ],
      commonOperate: {
        add: false,
        delete: false
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  treeData: {
    path: `${componentName}/getMenus`,
    payload: {
      key: `${componentName}@typeNodeList`,
      apiParams: {}
    }
  },
  changeDisable: {
    path: `${componentName}/changeDisable`,
    payload: {
      key: `${componentName}@changeDisable`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
